import React, { useState } from 'react';
import ConfirmationModal, { ModalProps } from '.';

export type ConfirmationModalData = Omit<ModalProps, 'open' | 'onClose' | 'onSubmit' | 'loading'>;

interface HookData {
  content: ConfirmationModalData;
  resolve: (result: boolean) => void;
}

export const useConfirmationModal = () => {
  const [data, setData] = useState<HookData | null>(null);

  const confirm = (modalData: ConfirmationModalData) => {
    return new Promise<boolean>((resolve) => {
      setData({
        content: modalData,
        resolve,
      });
    });
  };

  const handleClose = (result: boolean) => {
    if (!data) return;
    data.resolve(result);
    setData(null);
  };

  const confirmationModal = data ?
    <ConfirmationModal 
      open 
      onClose={() => handleClose(false)}
      onSubmit={() => handleClose(true)}
      {...data.content}
    />
    : null;

  return { confirm, confirmationModal };

};
